import { render, staticRenderFns } from "./CalendarioProgramacaoUnidade.vue?vue&type=template&id=139d6463&scoped=true"
import script from "./CalendarioProgramacaoUnidade.vue?vue&type=script&lang=js"
export * from "./CalendarioProgramacaoUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d6463",
  null
  
)

export default component.exports